module.exports = __webpack_public_path__ + "img/selected5-min.67c60fc7.png";